module.exports = __webpack_public_path__ + "img/guestfd.78868f05.png";